// dependency-graph-ignore-file
window.global ||= window; // Ensures that `global` is defined in the browser for libraries that require it.

import {
  currentBridgeData,
  initializeBridgeData,
} from '@databases/database-state/state/bridge-data';
import { mountDefaultFlagGroup } from '@databases/flags';
import { getAppModeFromQueryParams } from '@databases/modes';
import { initDatabasesRovoContentBridge } from '@databases/rovo-bridge';
import React from 'react';

import { setupCommentsPanelBridgeListeners } from '../bootstrap/comments-panel-listener';
import { dispatchInitialDatabaseLoad } from '../bootstrap/dispatch-initial-database-load';
import { getModeConfig } from '../bootstrap/get-mode-config';
import { getThemeStateFromQueryParams } from '../bootstrap/initialize-database-theme';
import { initializeRecyclableSelectionsMachine } from '../bootstrap/initialize-recyclable-selections-machine';
import { initializeTableHighlightsController } from '../bootstrap/initialize-table-highlights-controller';
import { preloadToolbar } from '../bootstrap/preload-toolbar';
import { registerPanelsForPanelRenderer } from '../bootstrap/register-panels-for-panel-renderer';

import { tryInitializeNativeEmbedBridge } from './bridge/try-initialize-native-embed-bridge';
import AppWithLocale from './components/app-with-locale';
import { createDatabasesApp } from './create-databases-app';

const run = createDatabasesApp(async ({ bootstrap, mount }) => {
  const {
    cloudId,
    spaceId,
    identity,
    contentId,
    spaceKey,
    spaceName,
    title,
    contentReferenceId,
  } = await initializeBridgeData();

  const appMode = getAppModeFromQueryParams(new URLSearchParams(window.location.search));
  const modeConfig = getModeConfig(appMode);

  await bootstrap({
    appMode,
    cloudId,
    identity,
    dependencies: modeConfig.dependencies,
    spaceId,
    themeState: getThemeStateFromQueryParams(),
  });

  preloadToolbar();
  registerPanelsForPanelRenderer();

  dispatchInitialDatabaseLoad({
    contentId,
    contentReferenceId,
    spaceId,
    spaceKey,
    spaceName,
    title,
  });

  if (appMode === 'NATIVE_EMBED') {
    await tryInitializeNativeEmbedBridge(() => currentBridgeData.data);
  }

  initDatabasesRovoContentBridge(contentId);
  setupCommentsPanelBridgeListeners();

  initializeTableHighlightsController();
  initializeRecyclableSelectionsMachine(contentId);

  mount((getRoot) => {
    const root = getRoot();

    root.render(<AppWithLocale />);

    mountDefaultFlagGroup();
  });
});

run();
